export default {
  banner: {
    title: "Authing Partner System",
    subtitle: "",
    join: "Join Now",
  },
  feature: {
    item1: {
      title: "Zero Trust Service Network",
      text:
        "Under the trend of telecommuting, zero-trust security service with identity as the core provides Adaptive MFA, security audit, unified identity management and unified authority management capabilities for the core assets, information security and personnel access of a wide range of enterprises, deeply empowering the construction of zero-trust networks for enterprises.",
    },
    item2: {
      title: "100 Billion Identity Cloud Market",
      text:
        "With the popularity of cloud computing and SaaS services in China, the attributes of identity as a basic service for enterprises have become prominent. The identity Internet with security as the entry point effectively solves the management pain points and unlocks the $120 billion blue ocean market.",
    },
    item3: {
      title: "IDaaS Development Trend",
      text:
        "According to Gartner statistics, the global market spending on identity and access management security in 2019 is $10.58 billion; the size of China's identity access management market will reach $3 billion in 2024, and the trend of traditional IAM to IDaaS is obvious.",
    },
    item4: {
      title: "Domestic Innovation Policy",
      text:
        "Innovation, as the key top-level design for China's software, will create a favorable development environment for head vendors with both independent and controllable capabilities; meanwhile, China's increasingly improved information security law has prompted companies to seek professional compliance solutions.",
    },
  },
  system: {
    title: "Partner Type",
    item1: {
      title: "Channel Partners",
      text:
        "Our channel partners jointly expand the market scale of our products by representing or integrating Authing products, and jointly enhance our product service capabilities to serve our customers throughout their lifecycle journey.",
    },
    item2: {
      title: "Eco-Partners",
      text:
        "Our eco-partners are technology partners or ISVs that have unique technologies or solutions to enhance our product capabilities. They expand our customers' usage scenarios and simplify their development process through Authing's collaborative network integration and solution linkage.",
    },
    item3: {
      title: "Managed Service Providers",
      text:
        "Managed service providers implement and run Authing instances on behalf of their customers, providing expertise to bring world-class identity products and services to their customers.",
    },
  },
  equity: {
    title1: "Channel cooperation",
    title2: "Partnership",
    item1: "Product Discount",
    item2: "Test Support",
    item3: "Expert Support",
    item4: "Significant Rebate",
    item5: "Professional Training",
    item6: {
      title: "Business Opportunity",
      extra: "",
    },
  },
  form: {
    title: "Apply to be an Authing partner",
    company: "Company Name",
    email: "Your enterprise email",
    address: "Location of your company",
    name: "Name",
    phone: "Phone",
    intend: "Industry",
  },
};
